import 'add-to-homescreen';
import { prop } from 'ramda';
import { useEffect } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import './useAddToHomeScreenPopup.scss';

export const useAddToHomeScreenPopup = () => {
    const needToShow = useAppSelector(prop('saveToHomeScreenPopUp'));
    const isInWrapper = useDeviceSelector(prop('isInWrapper'));
    const translate = useTranslations();

    useEffect(() => {
        if (!needToShow || isInWrapper) {
            return;
        }

        const message = translate('playtech.mobile.system.add2homescreen');
        const resetTopPosition = () => instance.viewport.style.top = '0';

        /* global addToHomescreen */
        const instance = addToHomescreen({
            message,
            onShow: () => {
                window.addEventListener('resize', resetTopPosition);
            },
            onRemove: () => {
                window.removeEventListener('resize', resetTopPosition);
            }
        });

    }, [needToShow, isInWrapper, translate]);
};
